import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import Cookies from 'js-cookie'
import axios from 'axios'

Vue.use(Vuex)

const state = {
  count: 0,
  authentication: undefined
}

const getters = {
  evenOrOdd: (state) => {
    return state.count % 2 === 0 ? 'even' : 'odd'
  },
  isAuthenticated: (state) => {
    if (!state.authentication ||
      state.authentication === undefined) {
      return false
    }

    var data = state.authentication
    if (!data ||
      !data.expires_in ||
      !data.token_type ||
      !data.access_token ||
      !data.refresh_token) {
      return false
    }

    return true
  },
  authenticatedUsername: (state) => {
    if (!state.authentication) {
      return ''
    }
    return state.authentication.email
  },
  authenticatedAuthorization: (state) => {
    if (!state.authentication ||
      !state.authentication.access_token ||
      !state.authentication.token_type) {
      return undefined
    }
    return state.authentication.token_type + ' ' + state.authentication.access_token
  }
}

const mutations = {
  increment (state) {
    state.count++
  },
  decrement (state) {
    state.count--
  },
  authenticated (state, data) {
    // console.log('mutation:authenticated')
    // console.log(data)
    state.authentication = data
  },
  unauthenticated (state) {
    // console.log('mutation:unauthenticated')
    state.authentication = undefined
  }
}

const actions = {
  increment: ({ commit }) => commit('increment'),
  decrement: ({ commit }) => commit('decrement'),
  incrementIfOdd ({ commit, state }) {
    if ((state.count + 1) % 2 === 0) {
      commit('increment')
    }
  },
  incrementAsync ({ commit }) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        commit('increment')
        resolve()
      }, 1000)
    })
  },
  authenticated ({ commit }, data) {
    // console.log('actions:authenticated')
    // console.log(data)

    if (!data ||
      !data.expires_in ||
      !data.token_type ||
      !data.access_token ||
      !data.refresh_token) {
      console.error('actions:authenticated:invalid authentication data', data)
      return
    }

    // set header & update cookie
    axios.defaults.headers.post['Authorization'] = data.token_type + ' ' + data.access_token
    axios.defaults.headers.get['Authorization'] = data.token_type + ' ' + data.access_token
    return commit('authenticated', data)
  },
  unauthenticated ({ commit }) {
    // console.log('actions:unauthenticated')

    // remove header & clear cookie
    axios.defaults.headers.post['Authorization'] = undefined
    axios.defaults.headers.get['Authorization'] = undefined
    return commit('unauthenticated')
  }
}

// authentication cookie store to store persistent storage
const authCookieStore = new VuexPersist({
  key: 'authorization',
  restoreState: (key, storage) => {
    // console.log('cookie:restoreState')
    // console.log(key)
    // console.log(state)
    var data = Cookies.getJSON(key)
    state.authentication = data
    if (!data || !data.token_type || !data.access_token) {
      // console.error('Invalid authorization')
      return Cookies.getJSON(key)
    }

    axios.defaults.headers.post['Authorization'] = data.token_type + ' ' + data.access_token
    axios.defaults.headers.get['Authorization'] = data.token_type + ' ' + data.access_token

    // hopefully the following doesn't simply bind to override
    return Cookies.getJSON(key)
  },
  saveState: (key, state, storage) => {
    // console.log('cookie:saveState')
    // console.log(key)
    // console.log(state)
    if (!state.authentication || state.authentication === undefined ||
      !state.authentication.expires_in || state.authentication.expires_in === undefined ||
      !state.authentication.access_token || state.authentication.access_token === undefined ||
      !state.authentication.refresh_token || state.authentication.refresh_token === undefined ||
      !state.authentication.token_type || state.authentication.token_type === undefined) {
      Cookies.remove(key)
      return
    }

    var expires = state.authentication.expires_in / 60 / 60 / 24
    console.log('cookie authentication expires in: ' + expires)
    return Cookies.set(key, state.authentication, {
      expires: expires
    })
  },
  reducer: (state) => {
    // console.log('cookie:reducer')
    // console.log(state)
    return { authentication: state.authentication }
  },
  filter: (mutation) => {
    // console.log('cookie:filter, mutation.type=' + mutation.type)
    return (mutation.type === 'authenticated' || mutation.type === 'unauthenticated')
  }
})

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
  plugins: [authCookieStore.plugin]
})



// WEBPACK FOOTER //
// ./src/controllers/Store.js